import React, { useEffect, useRef, useState } from "react";
import Matter from "matter-js";
import confirmationSound from "../../../src/Assets/confirmation_001.ogg";
import drop from "../../../src/Assets/drop_002.ogg";
import mainSounds from "../../../src/Assets/funk-it-49967.mp3";
import { getWallletBalance, getBetOptions, bettingResult } from "../../../src/Screens/Profile/UserEndpoints";
import { TiArrowBack } from "react-icons/ti";
import { CiBoxList, CiWallet } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { textStyle } from "../../../src/Utils/index";
import { message } from "antd";
import { AviatorImages } from "../../ImageController/Index";
import { getWinningHistory } from "./PlinkoEndpoint";

const isSmallScreen = window.innerWidth < 768;
const isMobile = window.innerWidth <= 768;
const isLandscapeInit = window.innerWidth > window.innerHeight;

const PEG_SPACING = isMobile ? (isLandscapeInit ? 18 : 22) : 30;
const ROWS = 14;
const BALL_RADIUS = isMobile ? (isLandscapeInit ? 5 : 6) : 8;

const CANVAS_WIDTH = isMobile
    ? (isLandscapeInit ? 22 * PEG_SPACING : 18 * PEG_SPACING)
    : 20 * PEG_SPACING;

const CANVAS_HEIGHT = isMobile
    ? (isLandscapeInit ? 400 : ROWS * PEG_SPACING + 300)
    : ROWS * PEG_SPACING + 200;

// ---- Collision categories (bitmasks)
const CATEGORY_DEFAULT = 0x0001; // Matter default (pegs, buckets, etc.)
const CATEGORY_GUIDE = 0x0002; // all guides share this category
// unique per slot: 0x0004, 0x0008, 0x0010, ...
const categoryForSlot = (slotNumber) => (1 << (slotNumber + 1)); // slot 1 -> 0x0004

const PlinkoWithPhysics = () => {
    const sceneRef = useRef(null);
    const engine = useRef(Matter.Engine.create());
    const renderRef = useRef(null);

    // guides per slot { [slotNumber]: { bodies: Body[], category: number } }
    const guideBySlotRef = useRef({});

    const [bucketPercentages, setBucketPercentages] = useState({ red: [], green: [], yellow: [] });
    const pegsRef = useRef([]);
    const confirmation = new Audio(confirmationSound);
    const dropSound = new Audio(drop);
    const mainSound = new Audio(mainSounds);
    const [walletBalance, setWalletBalance] = useState(0);
    const navigate = useNavigate();
    const [isLandscape, setIsLandscape] = useState(false);
    const [amount, setAmount] = useState(10);
    const [winningHistory, setWinningHistory] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [bucketLabels, setBucketLabels] = useState([]);

    // ----- your static slotPath data (unchanged)
    //   const slotPaths = {
    //     1: [{ index: 9.6, position: 20, left: 15, rightHeight: 300, rightPosition: 125, right: 125 }],
    //     2: [{ index: 9.6, position: 19, left: 9, rightHeight: 300, rightPosition: 125, right: 125 }],
    //     3: [{ index: 9.6, position: 80, left: 15, rightHeight: 300, rightPosition: 125, right: 125 }],
    //     4: [{ index: 9.6, position: 116.5, left: 10.1, rightHeight: 300, rightPosition: 15, right: 80 }],
    //     5: [{ index: 9.6, position: 40, left: 15, rightHeight: 300, rightPosition: 125, right: 125 }],
    //     6: [{ index: 9.6, position: 78, left: 36, rightHeight: 300, rightPosition: 125, right: 125 }],
    //     7: [{ index: 9.6, position: 58.9, left: 30, right: 70, rightHeight: 300, rightPosition: 31 }],
    //     8: [{ index: 9.6, position: 51, left: 10.5, right: 27, rightHeight: 300, rightPosition: 125 }],
    //     9: [{ index: 9.6, position: 55, left: 59, right: 125, rightHeight: 300, rightPosition: 125 }],
    //     10: [{ index: 9.6, position: 30, left: 40, right: 125, rightHeight: 300, rightPosition: 125 }],
    //     11: [{ index: 9.6, position: 38, left: 15, right: 50, rightHeight: 300, rightPosition: 164.9 }],
    //     12: [{ index: 9.6, position: 30, left: 15, right: 10, rightHeight: 300, rightPosition: 145 }],
    //     13: [{ index: 9.6, position: 38, left: 15, right: 17.7, rightHeight: 390, rightPosition: 170.9 }],
    //     14: [{ index: 9.6, position: 38, left: 15, right: 17.7, rightHeight: 430, rightPosition: 180.5 }],
    //     15: [{ index: 9.6, position: 54, left: 11, right: 125, rightHeight: 300, rightPosition: 7 }],
    //   };

    const slotPaths = {
        1: [
            { index: 9.6, position: 20, left: 15, rightHeight: 300, rightPosition: 125, right: 125 },
        ],
        2: [
            { index: 9.6, position: 19, left: 9, rightHeight: 300, rightPosition: 125, right: 125 },
        ],
        3: [
            { index: 9.6, position: 80, left: 15, rightHeight: 300, rightPosition: 125, right: 125 },
            // { index: 9.6, position: 19, left: 15, rightHeight: 300, rightPosition: 125, right: 125 },
            // { index: 9.6, position: 78, left: 15, rightHeight: 300, rightPosition: 125, right: 125 },
            // { index: 9.6, position: 99.9, left: 45, rightHeight: 300, rightPosition: 125, right: 125 },

        ],
        4: [
            { index: 9.6, position: 116.5, left: 10.1, rightHeight: 300, rightPosition: 15, right: 80 },

        ],
        5: [
            // { index: 9.6, position: 40, left: 15, rightHeight: 300, rightPosition: 125, right: 125 },
            { index: 9.6, position: 1, left: 33, rightHeight: 300, rightPosition: 15, right: 70 },
        ],
        6: [
            { index: 9.6, position: 78, left: 36, rightHeight: 300, rightPosition: 125, right: 125 },
            // { index: 9.6, position: 97.7, left: 65, right: 125, rightHeight: 300, rightPosition: 125 },
        ],
        7: [
            { index: 9.6, position: 58.9, left: 30, right: 70, rightHeight: 300, rightPosition: 31 },
            // { index: 9.6, position: 78, left: 35, rightHeight: 300, rightPosition: 125, right: 125 },
            // { index: 9.6, position: 42, left: 65, right: 125, rightHeight: 300, rightPosition: 125 },
        ],
        8: [
            // { index: 9.6, position: 35, left: 15, right: 125 },
            { index: 9.6, position: 35, left: 15, right: 120, rightHeight: 300, rightPosition: 184.5 },
            // { index: 9.6, position: 51, left: 10.5, right: 27, rightHeight: 300, rightPosition: 125 },
            // { index: 9.6, position: 13, left: 40, right: 125, rightHeight: 300, rightPosition: 125 },
        ],
        9: [
            { index: 9.6, position: 55, left: 59, right: 125, rightHeight: 300, rightPosition: 125 },
            // { index: 9.6, position: 13, left: 50, right: 23, rightHeight: 300, rightPosition: 146 },
            // { index: 9.6, position: 55, left: 50, right: 15, rightHeight: 300, rightPosition: 70 },
        ],
        10: [
            // { index: 9.6, position: 43, left: 50, right: 690, rightHeight: 300, rightPosition: 110 },
            { index: 9.6, position: 30, left: 40, right: 125, rightHeight: 300, rightPosition: 125 },
            // { index: 9.6, position: 42, left: 40, right: 45, rightHeight: 300, rightPosition: 155 },

        ],
        11: [
            { index: 9.6, position: 38, left: 15, right: 50, rightHeight: 300, rightPosition: 164.9 },
            // { index: 9.6, position: 65, left: 30, right: 30, rightHeight: 300, rightPosition: 3 },
            // { index: 9.6, position: 30, left: 50, right: 125, rightHeight: 300, rightPosition: 125 },
        ],
        12: [
            { index: 9.6, position: 30, left: 15, right: 10, rightHeight: 300, rightPosition: 145 },
            // { index: 9.6, position: 14, left: 40, right: 15, rightHeight: 300, rightPosition: 125 },
        ],
        13: [
            { index: 9.6, position: 38, left: 15, right: 17.7, rightHeight: 390, rightPosition: 180.9 },
            // { index: 9.6, position: 49, left: 11, right: 125, rightHeight: 300, rightPosition: 7 },
        ],
        14: [
            { index: 9.6, position: 38, left: 15, right: 17.7, rightHeight: 430, rightPosition: 180.5 },
            // { index: 9.6, position: 49, left: 11, right: 125,rightHeight:300, rightPosition: 7 },
        ],
        15: [
            { index: 9.6, position: 54, left: 11, right: 125, rightHeight: 300, rightPosition: 7 },
        ]
    };

    const slotPosition = {
        a: 1, b: 2, c: 3, d: 4, e: 5, f: 6, g: 7, h: 8,
        i: 9, j: 10, k: 11, l: 12, m: 13, n: 14, 0: 15,
    };

    // ---------------- Responsive helpers unchanged
    useEffect(() => {
        const mediaQuery = window.matchMedia("(orientation: landscape)");
        const handler = (e) => setIsLandscape(e.matches);
        setIsLandscape(mediaQuery.matches);
        mediaQuery.addEventListener("change", handler);
        return () => mediaQuery.removeEventListener("change", handler);
    }, []);

    // ---------------- Matter helpers

    const addBuckets = () => {
        const { World, Bodies } = Matter;
        const world = engine.current.world;

        const bucketFills = [];
        const bucketHeight = 50;
        const baseY = ROWS * PEG_SPACING + 55;

        const cols = ROWS + 2;
        const totalRowWidth = (cols - 1) * PEG_SPACING;
        const offsetX = (CANVAS_WIDTH - totalRowWidth) / 2;

        const colors = ["#5fca5f", "yellow", "red"];
        const verticalSpacing = 2;
        const horizontalPadding = 3;
        const labels = [];

        for (let i = 0; i < cols; i++) {
            const x = offsetX + i * PEG_SPACING;

            // side walls (default category)
            const wall = Bodies.rectangle(
                x,
                baseY + bucketHeight / 2,
                22,
                bucketHeight,
                {
                    isStatic: true,
                    render: { fillStyle: "#000" },
                    collisionFilter: { category: CATEGORY_DEFAULT, mask: 0xFFFF }
                }
            );
            World.add(world, wall);

            if (i < cols - 1) {
                const leftX = x;
                const rightX = x + PEG_SPACING;
                const centerX = (leftX + rightX) / 2;

                const boxWidth = PEG_SPACING - horizontalPadding;
                const boxHeight = 16;

                for (let j = 0; j < 3; j++) {
                    const fill = Bodies.rectangle(
                        centerX,
                        baseY + (boxHeight / 2) + j * (boxHeight + verticalSpacing),
                        boxWidth,
                        boxHeight,
                        {
                            isStatic: true,
                            render: { fillStyle: colors[j % colors.length] },
                            label: `bucket_${i}_fill_${j}`,
                            collisionFilter: { category: CATEGORY_DEFAULT, mask: 0xFFFF }
                        }
                    );
                    bucketFills.push(fill);
                }

                labels.push({ x: centerX, y: baseY + bucketHeight + 45, index: i });
            }
        }

        // invisible detectors
        for (let i = 0; i < cols - 1; i++) {
            const leftX = offsetX + i * PEG_SPACING;
            const rightX = offsetX + (i + 1) * PEG_SPACING;
            const centerX = (leftX + rightX) / 2;

            const detector = Bodies.rectangle(
                centerX,
                baseY + bucketHeight + 30,
                PEG_SPACING - 10,
                10,
                {
                    isStatic: true,
                    isSensor: true,
                    render: { fillStyle: "transparent" },
                    label: `detector-${i}`,
                    collisionFilter: { category: CATEGORY_DEFAULT, mask: 0xFFFF }
                }
            );
            World.add(world, detector);
        }

        Matter.World.add(world, bucketFills);
        setBucketLabels(labels);
    };

    const generatePegPositions = () => {
        const pegs = [];
        for (let row = 0; row < ROWS; row++) {
            const cols = row + 3;
            const totalRowWidth = (cols - 1) * PEG_SPACING;
            const offsetX = (CANVAS_WIDTH - totalRowWidth) / 2;
            for (let col = 0; col < cols; col++) {
                const x = offsetX + col * PEG_SPACING;
                const y = 60 + row * PEG_SPACING;
                pegs.push({ x, y });
            }
        }
        return pegs;
    };

    const addPegs = () => {
        const { World, Bodies } = Matter;
        const world = engine.current.world;
        pegsRef.current = generatePegPositions().map(({ x, y }) =>
            Bodies.circle(x, y, 5, {
                isStatic: true,
                render: { fillStyle: "#fff" },
                collisionFilter: { category: CATEGORY_DEFAULT, mask: 0xFFFF }
            })
        );
        World.add(world, pegsRef.current);
    };

    // ---- NEW: guides only collide with the ball for that slot
    const addStaticGuidePathToSlot = (slotNumber) => {
        const { World, Bodies } = Matter;
        const world = engine.current.world;
        const paths = slotPaths[slotNumber];
        if (!paths || paths.length === 0) {
            console.warn(`No path data for slot ${slotNumber}`);
            return null;
        }

        // If guides already exist for this slot, remove them first
        if (guideBySlotRef.current[slotNumber]?.bodies?.length) {
            guideBySlotRef.current[slotNumber].bodies.forEach(b => World.remove(world, b));
        }

        const path = paths[Math.floor(Math.random() * paths.length)];
        const pathBodies = [];

        const slotX = path.index * PEG_SPACING;
        const slotCat = categoryForSlot(slotNumber); // unique category for this slot's ball

        // Left wall
        if (path.left !== undefined && path.position !== undefined) {
            const funnelLeft = Bodies.rectangle(
                slotX - path.position, ROWS * PEG_SPACING / 2,
                10, 330,
                {
                    isStatic: true,
                    angle: Math.PI / path.left,
                    render: { visible: false },
                    collisionFilter: {
                        category: CATEGORY_GUIDE,     // all guides share this category
                        mask: slotCat                 // BUT only collide with this slot's ball
                    }
                }
            );
            funnelLeft.plugin = { slotNumber };
            pathBodies.push(funnelLeft);
        }

        // Right wall
        if (path.right !== undefined && (path.rightPosition !== undefined || path.position !== undefined)) {
            const rightPos = path.rightPosition ?? path.position;
            const funnelRight = Bodies.rectangle(
                slotX + rightPos, ROWS * PEG_SPACING / 2,
                10, path.rightHeight,
                {
                    isStatic: true,
                    angle: -Math.PI / path.right,
                    render: { visible: false },
                    collisionFilter: {
                        category: CATEGORY_GUIDE,
                        mask: slotCat
                    }
                }
            );
            funnelRight.plugin = { slotNumber };
            pathBodies.push(funnelRight);
        }

        World.add(world, pathBodies);
        guideBySlotRef.current[slotNumber] = { bodies: pathBodies, category: slotCat };
        return slotCat;
    };

    // ---- NEW: drop ball tagged to a slot (so it collides only with that slot's guides)
    const dropBallForSlot = (colorIndex, slotNumber) => {
        const { World, Bodies } = Matter;
        const slotCat = guideBySlotRef.current[slotNumber]?.category || categoryForSlot(slotNumber);

        // pick horizontal spawn from path.index (same as your guides)
        const path = slotPaths[slotNumber]?.[0];
        const xIndex = path?.index ?? 9.6;
        const ballX = xIndex * PEG_SPACING;

        const ball = Bodies.circle(
            ballX,
            10,
            BALL_RADIUS,
            {
                restitution: 0.3,
                friction: 0.05,
                label: `plinko-ball-${slotNumber}`,
                render: { fillStyle: colorIndex === 0 ? "green" : colorIndex === 1 ? "yellow" : "red" },
                collisionFilter: {
                    category: slotCat,                    // this ball belongs to the slot category
                    mask: CATEGORY_DEFAULT | CATEGORY_GUIDE // collide with pegs/buckets + guides
                }
            }
        );
        World.add(engine.current.world, ball);
    };

    // ---------------- API helpers

    const betOptions = () => {
        getBetOptions()
            .then((res) => {
                if (res.status && res.data) {
                    const formatted = { red: [], green: [], yellow: [] };
                    res.data.forEach((item) => {
                        if (formatted[item.option_type]) {
                            formatted[item.option_type] = item.option_percentage;
                        }
                    });
                    setBucketPercentages(formatted);
                }
            })
            .catch((err) => console.log(err));
    };

    // ---- CHANGED: return the slot number; create guides before dropping ball
    const handleApplyBet = async (colour, colorIndex) => {
        try {
            const res = await bettingResult({ amount, betType: colour });
            if (res?.status) {
                message.success("Bet Applied Successfully!", 3);

                const locKey = res?.loc;                 // e.g., "a".."n" or "0"
                const slotNum = slotPosition[locKey];    // 1..15

                // 1) add guides for that slot (with unique mask)
                addStaticGuidePathToSlot(slotNum);

                // 2) drop ball that belongs to that slot (will collide only with its guides)
                dropBallForSlot(colorIndex, slotNum);

                // 3) housekeeping
                userWalletBal();
                getHistory();
                return slotNum;
            }
        } catch (err) {
            console.log(err);
        }
        return null;
    };

    const handleClickThrottled = (colorIndex, colorName) => {
        // Now we wait for bet -> slot -> create guides -> drop ball for that slot
        handleApplyBet(colorName, colorIndex);
    };

    const userWalletBal = () => {
        getWallletBalance()
            .then((res) => {
                if (res.status) setWalletBalance(res.data?.balance);
            })
            .catch((err) => console.log(err));
    };

    const getHistory = () => {
        getWinningHistory()
            .then((res) => {
                if (res?.status) setWinningHistory(res?.data?.map((i) => i.multiple_percentage));
            })
            .catch((err) => console.log(err));
    };

    // ---------------- Engine boot + collisions

    useEffect(() => {
        const { Engine, Render, Runner, World, Events } = Matter;

        engine.current.world.gravity.y = 0.5;

        const render = Matter.Render.create({
            element: sceneRef.current,
            engine: engine.current,
            options: {
                width: CANVAS_WIDTH,
                height: CANVAS_HEIGHT,
                wireframes: false,
                background: "transparent",
            },
        });

        userWalletBal();
        getHistory();
        betOptions();

        renderRef.current = render;

        const bgImage = new Image();
        bgImage.src = AviatorImages.bgImg;
        const drawBackground = () => {
            const context = render.context;
            context.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
            context.drawImage(bgImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
        };
        const originalRenderWorld = render.world;
        render.world = function () {
            drawBackground();
            originalRenderWorld.call(this);
        };

        addPegs();
        addBuckets();

        Engine.run(engine.current);
        Render.run(render);
        const runner = Runner.create();
        Runner.run(runner, engine.current);

        Events.on(engine.current, "collisionStart", (event) => {
            const { World } = Matter;
            event.pairs.forEach(({ bodyA, bodyB }) => {
                const labels = [bodyA.label, bodyB.label];
                const isBallA = /^plinko-ball-/.test(bodyA?.label || "");
                const isBallB = /^plinko-ball-/.test(bodyB?.label || "");
                const ball = isBallA ? bodyA : isBallB ? bodyB : null;

                // peg hit sound
                if (
                    (isBallA || isBallB) &&
                    (pegsRef.current.includes(bodyA) || pegsRef.current.includes(bodyB))
                ) {
                    const s = dropSound.cloneNode();
                    s.play().catch(() => { });
                }

                // bucket sensor or fill hit
                const bucketHit =
                    labels.some((l) => (l || "").startsWith("bucket_")) ||
                    labels.some((l) => (l || "").startsWith("detector-"));

                if (ball && bucketHit) {
                    const s = confirmation.cloneNode();
                    s.play().catch(() => { });

                    // remove the ball
                    World.remove(engine.current.world, ball);

                    // parse slot from ball label: "plinko-ball-<slot>"
                    const match = (ball.label || "").match(/^plinko-ball-(\d+)$/);
                    const slotNum = match ? Number(match[1]) : null;

                    // remove only that slot's guides
                    if (slotNum && guideBySlotRef.current[slotNum]?.bodies?.length) {
                        guideBySlotRef.current[slotNum].bodies.forEach((b) =>
                            World.remove(engine.current.world, b)
                        );
                        guideBySlotRef.current[slotNum] = { bodies: [], category: categoryForSlot(slotNum) };
                    }
                }
            });
        });

        return () => {
            Render.stop(render);
            Engine.clear(engine.current);
            render.canvas.remove();
            render.textures = {};
        };
    }, []);

    // ---------------- UI bits (unchanged except click handler)

    const handlePricingClick = (value) => { setAmount(value); setShowModal(false); };
    const handleReset = () => setAmount(10);

    return (

        <>
            {isSmallScreen && !isLandscape ? (

                <div className=" font-semibold bg-black text-yellow-500 flex justify-center h-screen text-xl font-inter animate-lightThunder items-center">
                    <p>Please Rotate Your Device</p>
                </div>
            ) :
                <>
                    <div
                        style={{ zIndex: 9999 }}
                        className="flex justify-start items-center gap-6 absolute top-4 left-4"
                    >
                        <TiArrowBack
                            onClick={() => navigate(-1)}
                            color="yellow"
                            className="border-2 w-12 h-12 bg-yellow-600 cursor-pointer border-yellow-500 rounded-md p-3"
                            size={25}
                        />
                        {/* <p style={textStyle} className=" font-bold">
                Room Id:{roomDetail?.room_id}
            </p> */}
                    </div>
                    <div
                        style={{ zIndex: 1 }}
                        className="flex justify-start items-center gap-2 absolute top-4 right-4"
                    >
                        <CiWallet
                            color="yellow"
                            className="border-2 w-12 h-12 bg-yellow-600 cursor-pointer border-yellow-500 rounded-md p-3"
                            size={25}
                        />
                        <p style={textStyle} className=" font-bold">
                            Wallet:{walletBalance}
                        </p>
                    </div>


                    <div className="plinko-container relative  " style={{ textAlign: "center", backgroundImage: `url(${AviatorImages.bgImg})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                        <div className="mt-[7%] relative " ref={sceneRef}>
                            <div className="absolute top-[97px] left-[40.5rem]" >
                                {bucketLabels.map((bucket, index) => (
                                    <div
                                        key={index}
                                        className="absolute text-xs font-bold text-center drop-shadow"
                                        style={{
                                            left: `${bucket.x - 680}px`,
                                            top: `${bucket.y - 190}px`, // 🧭 Move it above the bucket
                                            width: '60px',
                                            lineHeight: '1.4',
                                        }}
                                    >
                                        <div style={{ color: "black" }}>{bucketPercentages.green[bucket.index] || "--"}</div>
                                        <div style={{ color: "black" }}>{bucketPercentages.yellow[bucket.index] || "--"}</div>
                                        <div style={{ color: "black" }}>{bucketPercentages.red[bucket.index] || "--"}</div>
                                    </div>
                                ))}
                            </div>
                        </div>






                        <div className="bg-[#3f3863] absolute bottom-0 w-full sm:w-[90%] max-w-4xl mx-auto rounded-t-3xl sm:rounded-3xl p-4 flex flex-wrap justify-center sm:justify-between items-center gap-4 shadow-xl z-10">
                            <div className="flex items-center bg-[#2d284a] rounded-full px-4 py-2 space-x-3 shadow-inner min-w-[200px]">
                                <button
                                    className="text-white text-xl font-bold px-3 hover:text-[#00d1ff] transition"
                                    onClick={() => amount >= 20 && setAmount(amount - 10)}
                                >
                                    -
                                </button>

                                <input
                                    type="number"
                                    className="w-[60px] text-center font-bold text-white bg-black border border-transparent focus:border-[#00d1ff] rounded-md h-10"
                                    value={amount}
                                    onChange={(e) => setAmount(Number(e.target.value))}
                                />

                                <button
                                    className="text-white text-xl font-bold px-3 hover:text-[#00d1ff] transition"
                                    onClick={() => setAmount(amount + 10)}
                                >
                                    +
                                </button>

                                <button
                                    className=""
                                    onClick={() => setShowModal(true)}
                                >
                                    <CiBoxList />
                                </button>
                            </div>
                            <button
                                className="text-white text-2xl hover:rotate-180 transition-transform duration-300"
                                onClick={handleReset}
                                title="Reset"
                            >
                                🔄
                            </button>

                            <div className="flex gap-2">
                                <button
                                    onClick={() => handleClickThrottled(0, "green")}
                                    className="px-3 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white text-sm"
                                >
                                    Green
                                </button>
                                <button
                                    onClick={() => handleClickThrottled(1, "yellow")}
                                    className="px-3 py-2 rounded-lg bg-yellow-400 hover:bg-yellow-500 text-white text-sm"
                                >
                                    Yellow
                                </button>
                                <button
                                    onClick={() => handleClickThrottled(2, "red")}
                                    className="px-3 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white text-sm"
                                >
                                    Red
                                </button>
                            </div>
                            {showModal && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                    <div className="bg-white p-6 rounded-xl shadow-xl text-center space-y-4 max-w-sm w-full">
                                        <h2 className="text-lg font-bold">Choose Bet Amount</h2>
                                        <div className="grid grid-cols-3 gap-3">
                                            {[100, 200, 300, 500, 1000, 5000].map((value) => (
                                                <button
                                                    key={value}
                                                    onClick={() => handlePricingClick(value)}
                                                    className="px-4 py-2 bg-[#3f3863] text-white rounded hover:bg-[#5c5290]"
                                                >
                                                    {value}
                                                </button>
                                            ))}
                                        </div>
                                        <button
                                            onClick={() => setShowModal(false)}
                                            className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>


                        <div
                            style={{ boxShadow: "inset 0 4px 4px 0 #00000040", zIndex: 10 }}
                            className="absolute top-28 sm:top-20 md:top-12 lg:top-10 w-[80%] sm:w-[60%] md:w-[50%] lg:w-[40%] gap-2 p-1 rounded-full bg-sky-200 flex justify-center items-center"
                        >
                            {winningHistory.map((i, index) => (
                                <p
                                    key={index}
                                    style={{
                                        boxShadow: "inset 0 2px 0 0 #7e3732,inset 0 -3px 0 0 #cf756f",
                                    }}
                                    className="w-5 h-5 sm:w-6 sm:h-6 text-xs flex justify-center items-center bg-[#a55650] text-white font-semibold text-center rounded-full"
                                >
                                    {i}
                                </p>
                            ))}
                        </div>

                    </div>
                </>
            }
        </>

    );
};

export default PlinkoWithPhysics;
